import * as React from 'react';
import { Button } from './Button';
import { withTheme } from 'styled-components';

interface Props {
  click?: () => void;
  theme: any;
}
class ButtonSecondary extends React.Component<Props> {
  render() {
    const { children, click, theme } = this.props;
    return (
      <Button
        width={'100%'}
        height={'40px'}
        color={theme.btnSecondary}
        fontSize={'16px'}
        click={click}
        fontColor={theme.btnSecondaryTextColor}
      >
        {children}
      </Button>
    );
  }
}

export default withTheme(ButtonSecondary);
